var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer",attrs:{"app":"","inset":""}},[_c('v-spacer'),_vm._v("\n        © "+_vm._s(new Date().getFullYear())+" Vreet. All rights reserved.\n    ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }